import { DirectorySchemaData } from 'api/types/data/directory/directory';
import { setEndOfDay, setStartOfDay } from 'helpers';
import { object, string, date } from 'libs/form';

export const useValidationSchema = (currentSchema?: DirectorySchemaData) =>
  object(
    currentSchema?.fieldDefinitions.reduce((acc, fieldDefinition) => {
      let validationSchema;

      switch (fieldDefinition?.component) {
        case 'Select':
          validationSchema = object().default(null).nullable();
          break;
        case 'Country':
          validationSchema = object().default(null).nullable();
          break;
        case 'Datetime':
          validationSchema = date();
          if (fieldDefinition.validation?.date?.min instanceof Date) {
            validationSchema = validationSchema.min(
              setStartOfDay(fieldDefinition.validation.date.min)
            );
          }
          if (fieldDefinition.validation?.date?.max instanceof Date) {
            validationSchema = validationSchema.max(
              setEndOfDay(fieldDefinition.validation.date.max)
            );
          }
          break;
        case 'Input':
          validationSchema = string();

          if (
            typeof fieldDefinition.validation?.string?.length?.exact ===
            'number'
          ) {
            validationSchema = validationSchema
              .min(fieldDefinition.validation?.string?.length?.exact)
              .max(fieldDefinition.validation?.string?.length?.exact);
          }

          if (
            typeof fieldDefinition.validation?.string?.length?.max === 'number'
          ) {
            validationSchema = validationSchema.max(
              fieldDefinition.validation?.string?.length?.max
            );
          }

          if (
            typeof fieldDefinition.validation?.string?.length?.min === 'number'
          ) {
            validationSchema = validationSchema.min(
              fieldDefinition.validation?.string?.length?.min
            );
          }

          if (fieldDefinition.validation?.string?.pattern) {
            validationSchema = validationSchema.matches(
              RegExp(fieldDefinition.validation?.string?.pattern)
            );
          }
          break;

        case 'Decimal':
        default:
          validationSchema = string();

          if (typeof fieldDefinition.validation?.decimal?.max === 'number') {
            validationSchema = validationSchema.max(
              fieldDefinition.validation?.decimal?.max
            );
          }
          break;
      }

      if (fieldDefinition.isRequired) {
        validationSchema = validationSchema.required();
      }
      return {
        ...acc,
        [fieldDefinition.name]: fieldDefinition.isMultiLanguage
          ? object({
              ru: validationSchema,
              en: validationSchema,
            })
          : validationSchema,
      };
    }, {})
  );
